<template>
  <div :class="prefixCls">
    <div :class="[prefixCls + '-nav']" ref="nav">
        <div :class="tabCls(item)" v-for="(item, index) in navList" @click="handleChange(index)" :key="prefixCls + '-tab-' + index">
          <span>{{ item.label }}</span>
        </div>
        <div :class="[prefixCls + '-tabbar']" ref="navBar"></div>
    </div>
    <div :class="[prefixCls + '-panes']" ref="panes"><slot></slot></div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'

const prefixCls = 'x-tabs'

export default {
  name: 'XTabs',
  props: {
    value: {
      type: [String, Number]
    }
  },
  data () {
    return {
      prefixCls: prefixCls,
      navList: [],
      activeKey: this.value,
      prevKey: ''
    }
  },
  watch: {
    value (val, oldVal) {
      this.activeKey = val
    },
    activeKey (val, oldVal) {
      this.prevKey = oldVal
      this.updateBar()
      this.updateStatus()
    }
  },
  updated () {
    this.updateBar()
    this.updateStatus()
  },
  methods: {
    getTabs () {
      return this.$children.filter(item => item.$options.name === 'XTabPane')
    },
    getTabIndex (name) {
      return this._.findIndex(this.navList, nav => nav.name === name)
    },
    getPrevIndex (index) {
      let prevIndex = index - 1
      if (prevIndex < 0) {
        prevIndex = 0
      }
      return prevIndex
    },
    getNextIndex (index) {
      let nextIndex = index + 1
      if (index >= this.navList.length) {
        nextIndex = this.navList.length - 1
      }
      return nextIndex
    },
    updateNav () {
      this.navList = []
      this.getTabs().forEach((pane, index) => {
        this.navList.push({
          label: pane.label,
          name: pane.currentName || index
        })
        if (!pane.currentName) pane.currentName = index
        if (index === 0) {
          if (!this.activeKey) this.activeKey = pane.currentName || index
        }
      })
      this.updateBar()
      this.updateStatus()
    },
    updatePanesHeight (tabpane) {
      let itemHeight = this._h.getOuterElSize(tabpane.$children[0].$el).height
      let count = tabpane.$children.length
      let tabpaneHeight = itemHeight * count
      tabpane.$el.style.height = tabpaneHeight + 'px'
      return this._h.getOuterElSize(tabpane.$el).height
    },
    updateStatus () {
      if (this.prevKey === this.activeKey) return
      if (!this.$refs.nav) return
      const tabs = this.getTabs()
      if (!this.prevKey) {
        if (tabs.length === 0) return
        tabs[0].show = true
        let tabpaneHeight = this.updatePanesHeight(tabs[0])
        this.$refs.panes.style.height = tabpaneHeight + 'px'
      } else {
        let prevIndex = this.getTabIndex(this.prevKey)
        if (prevIndex === -1) return
        let index = this.getTabIndex(this.activeKey)
        if (index === -1) return
        tabs[index].show = true
        let tabpaneHeight = this.updatePanesHeight(tabs[index])
        if (tabpaneHeight > 0) {
          Velocity(this.$refs.panes, {height: tabpaneHeight}, {duration: 100, delay: 50})
        }
        if (index > prevIndex) {
          let tabWidth = this._h.getOuterElSize(this.$el)
          tabs[index].$el.style.left = tabWidth.width
          Velocity(tabs[prevIndex].$el, {left: -tabWidth.width}, { duration: 200 })
          Velocity(tabs[index].$el, {left: 0}, {
            duration: 200,
            complete: () => {
              this.$emit('changed', this.activeKey)
            }
          })
        } else {
          let tabWidth = this._h.getOuterElSize(this.$el)
          tabs[index].$el.style.left = -tabWidth.width
          Velocity(tabs[prevIndex].$el, {left: tabWidth.width}, { duration: 200 })
          Velocity(tabs[index].$el, {left: 0}, {
            duration: 200,
            complete: () => {
              this.$emit('changed', this.activeKey)
            }
          })
        }
      }
    },
    updateBar () {
      if (this.prevKey === this.activeKey) return
      let index = this.getTabIndex(this.activeKey)
      if (index === -1 || !this.$refs.nav) return
      if (!this.$refs.nav.querySelector(`.${prefixCls}-tab-active`)) return
      let tabs = this.$refs.nav.querySelectorAll(`.${prefixCls}-tab`)
      let currentTab = tabs[index]
      let navWidth = this._h.getOuterElSize(currentTab).width
      let offset = 0
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          offset += parseFloat(this._h.getOuterElSize(tabs[i]).width)
        }
      }
      Velocity(this.$refs.navBar, {width: navWidth, left: offset}, { duration: 200 })
    },
    tabCls (item) {
      return [`${prefixCls}-tab`, {
        [`${prefixCls}-tab-active`]: item.name === this.activeKey
      }]
    },
    chkOnlyBar (name) {
      let xTabs = this.$parent.$children.filter(item => item.$options['_componentTag'] === 'XTabs')
      this._.each(xTabs, (xTab) => {
        let index = xTab.getTabIndex(name)
        if (index === -1) {
          let nav = xTab.$refs.nav.querySelector(`.${prefixCls}-tab-active`)
          if (nav) {
            nav.className = nav.className.replace(new RegExp(`${prefixCls}-tab-active`), '')
          }
          Velocity(xTab.$refs.navBar, {width: 0}, { duration: 200 })
        } else {
          this.updateBar()
        }
      })
    },
    handleChange (index) {
      let nav = this.navList[index]
      let tab = this.$refs.nav.querySelectorAll(`.${prefixCls}-tab`)[index]
      tab.className += ` ${prefixCls}-tab-active`
      this.activeKey = nav.name
      this.chkOnlyBar(this.activeKey)
      this.$emit('beforeChange', nav.name)
    }
  }
}
</script>
<style scoped>
.x-tabs{
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  color: #495060;
  zoom: 1;
}
.x-tabs-nav{
  border-bottom: 1px solid #dddee1;
  margin-bottom: 16px;
  outline: 0;
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  position: relative;
  font-size: 14px;
  line-height: 1.5;
  zoom: 1;
}
.x-tabs-tab{
  margin-right: 0;
  padding: 0 16px 8px;
  font-size: 12px;
  display: inline-block;
  height: 100%;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  position: relative;
}
.x-tabs-tabbar{
  height: 1px;
  box-sizing: border-box;
  background-color: #2d8cf0;
  position: absolute;
  left: 0;
  width: 0;
  bottom: 0;
  z-index: 1;
}
.x-tabs-panes{
  position: relative;
  width: 100%;
}
.x-tabs-tabpane{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/xtabs/XTabs.vue